import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import { AuthProvider } from "./contexts/AuthContext";
import RequireAdmin from "./components/RequireAdmin";

import Home from "./pages/Home";
import Curriculum from "./pages/Curriculum";
import Compromisos from "./pages/Compromisos";
import Decalogo from "./pages/Decalogo";
import Contacto from "./pages/Contacto";
import Especialidad from "./pages/Especialidad";
import Articulo from "./pages/Articulo";
import Testimonios from "./pages/Testimonios";
import Enlaces from "./pages/Enlaces";
import DatoSemana from "./pages/DatoSemana";
import Blog from "./pages/Blog";
import NotFound from "./pages/NotFound";

// Admin imports
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminArticles from "./pages/admin/AdminArticles";
import AdminArticleEditor from "./pages/admin/AdminArticleEditor";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminChangePassword from "./pages/admin/AdminChangePassword";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Public routes with Layout */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="curriculum" element={<Curriculum />} />
              <Route path="compromisos" element={<Compromisos />} />
              <Route path="decalogo" element={<Decalogo />} />
              <Route path="contacto" element={<Contacto />} />
              <Route path="testimonios" element={<Testimonios />} />
              <Route path="enlaces" element={<Enlaces />} />
              <Route path="dato-semana" element={<DatoSemana />} />
              <Route path="especialidades/:slug" element={<Especialidad />} />
              <Route path="blog" element={<Blog />} />
              <Route path="articulos/:slug" element={<Articulo />} />
            </Route>

            {/* Admin login - no layout */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected admin routes */}
            <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
              <Route index element={<AdminDashboard />} />
              <Route path="articulos" element={<AdminArticles />} />
              <Route path="articulos/nuevo" element={<AdminArticleEditor />} />
              <Route path="articulos/:id/editar" element={<AdminArticleEditor />} />
              <Route path="mensajes" element={<AdminMessages />} />
              <Route path="cambiar-password" element={<AdminChangePassword />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
